import type { Transition } from 'framer-motion';

/** Переход по умолчанию для framer-motion в трекере. Те же значения — в styles/motion.scss */
export const MOTION_TRANSITION: Transition = { duration: 0.2, ease: [0.2, 0, 0, 1] };
